// **********************************************************
// Product Card Slider
// **********************************************************

const productCardSlider = document.querySelectorAll('[data-slider="product-card-swiper"]');

const productCardSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  watchOverflow: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'progressbar',
  },
  breakpoints: {
    767: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
};

const initProductCardSlider = (el) => {
  const parentEle = el.closest('.product-card-slider');

  const arrowRight = parentEle.querySelector('.arrow-right');
  const arrowLeft = parentEle.querySelector('.arrow-left');
  const pagination = parentEle.querySelector('.swiper-pagination');

  const options = {
    ...productCardSliderOptions,
    pagination: {
      ...productCardSliderOptions.pagination,
      el: pagination,
    },
    navigation: {
      prevEl: arrowLeft,
      nextEl: arrowRight,
    },
  };

  new Swiper(el, options);
};

productCardSlider.forEach((el) => initProductCardSlider(el));

setupResponsiveSliders({
  sliderElements: productCardSlider,
  breakpoint: breakpointSm,
  initSlider: initProductCardSlider,
  mobileFallback: [enableProgressSync, enableArrowScrollSync],
  parentSelector: '[data-slider-parent]',
});
